  // dropdown open and hide when click outside
  const dropdown = function (dropdownLinksSelector, dropdownInnerElementsSelector, dropdownInnerElementsInsideSelector) {

    const dropdownLinks = document.querySelectorAll(dropdownLinksSelector);
    const dropdownInnerElements = document.querySelectorAll(dropdownInnerElementsSelector);

    function dropdownClick(e) {
      const targetElement = document.getElementById(this.hash.substr(1));
      const isAlreadyActive = this.classList.contains('active');

      dropdownLinks.forEach(link => {
        link.classList.remove('active');
        link.setAttribute('aria-expanded', 'false');
      });

      dropdownInnerElements.forEach(el => el.classList.remove('open'));

      if (!isAlreadyActive) {
        dropdownLinks.forEach(link => {
          if (link.getAttribute('href') === this.hash) {
            link.classList.add('active');
            link.setAttribute('aria-expanded', 'true');
          }
        });
        targetElement.classList.add('open');
      }

      if (this.classList.contains('js-hamburger')) {
        if (this.classList.contains('active')) {
          document.body.classList.add('nav-opened');
        } else {
          document.body.classList.remove('nav-opened');
        }
      }

      e.preventDefault();
    }

    function handleMouseUpTouchStartKeyUp(e) {
      if (e.type === 'keyup' && e.key !== 'Escape') return;

      let clickedInsideAnyDropdown = false;

      dropdownLinks.forEach((link, i) => {
        const dropdownId = link.hash?.substr(1);
        const relatedDropdown = document.getElementById(dropdownId);

        if (relatedDropdown) {
          const insideSelectors = dropdownInnerElementsInsideSelector ?
            document.querySelectorAll(dropdownInnerElementsInsideSelector) : [];

          const isClickInside =
            link.contains(e.target) ||
            relatedDropdown.contains(e.target) ||
            Array.from(insideSelectors).some(el => el.contains(e.target));

          if (isClickInside) {
            clickedInsideAnyDropdown = true;
          }
        }
      });

      if (!clickedInsideAnyDropdown || e.key === 'Escape') {
        dropdownLinks.forEach(link => {
          link.classList.remove('active');
          link.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('nav-opened');
        });
        dropdownInnerElements.forEach(el => el.classList.remove('open'));
      }
    }

    dropdownLinks.forEach(link => link.addEventListener('click', dropdownClick));
    document.addEventListener('mouseup', handleMouseUpTouchStartKeyUp);
    document.addEventListener('touchstart', handleMouseUpTouchStartKeyUp);
    document.addEventListener('keyup', handleMouseUpTouchStartKeyUp);
  };

  dropdown('.js-dropdown-link', '.js-dropdown', null);